module.exports = __webpack_public_path__ + "static/media/game-background-vocabulary.eecb5720.jpg";